import { useMemo, useState } from 'react';
import { Form, Input } from 'antd';

import { searchFn } from '../../utils';
import { AmountInput, Card, EmptyState, SearchInput } from '../../components';
import { useI18n } from '../../i18n';

export const ProductFields = ({ branches, branchFieldName = id => id }) => {
  const { t } = useI18n();
  const [branchSearchValue, setBranchSearchValue] = useState('');

  const visibleIds = useMemo(() => {
    if (!branchSearchValue || !Array.isArray(branches)) return null;
    return new Set(searchFn(branches, branchSearchValue).map(branch => branch.id));
  }, [branches, branchSearchValue]);

  const required = field => [{ required: true, message: t('validation.required', { field }) }];
  const currency = t('common.currency');

  return (
    <>
      <Card title={t('products.general')} className='wm-form-section'>
        <Form.Item label={t('products.name')} name='name' rules={required(t('products.name'))}>
          <Input placeholder={t('products.namePlaceholder')} />
        </Form.Item>
        <div className='wm-field-grid'>
          <Form.Item label={t('products.buyPrice')} name='buy_price' rules={required(t('products.buyPrice'))}>
            <AmountInput placeholder={t('products.buyPricePlaceholder')} suffix={currency} />
          </Form.Item>
          <Form.Item label={t('products.quantity')} name='quantity' rules={required(t('products.quantity'))}>
            <AmountInput placeholder={t('products.quantityPlaceholder')} suffix={t('common.pcs')} />
          </Form.Item>
        </div>
      </Card>

      <Card
        title={t('products.branchPrices')}
        subtitle={t('products.branchPricesHint')}
        className='wm-form-section'
        extra={
          <SearchInput
            value={branchSearchValue}
            onChange={setBranchSearchValue}
            placeholder={t('products.searchBranch')}
          />
        }
      >
        {!branches?.length && <EmptyState compact />}
        {visibleIds && visibleIds.size === 0 && <EmptyState variant='search' compact />}
        <div className='wm-qty-list'>
          {branches?.map(branch => (
            <div
              className='wm-qty-row'
              key={branch.id}
              style={visibleIds && !visibleIds.has(branch.id) ? { display: 'none' } : undefined}
            >
              <div className='wm-qty-row__name'>{branch.name}</div>
              <Form.Item name={branchFieldName(branch.id)} rules={required(t('products.sellPrice'))}>
                <AmountInput placeholder={t('products.sellPrice')} aria-label={branch.name} />
              </Form.Item>
            </div>
          ))}
        </div>
      </Card>
    </>
  );
};
